import { useQuery } from '@tanstack/react-query';
import secureLocalStorage from 'react-secure-storage';
import { serverRequest } from "../../../util/server_request";
import { extractErrorMessage } from '../../extractErrorMessage';
import { notifyUser } from '../../../util/util';

const notifiedErrors = new Set();

const notifyOnce = (type, message, title = "") => {
  if (!notifiedErrors.has(message)) {
    notifiedErrors.add(message);
    notifyUser(type, message, title);
  }
};

// Fetches pension contributions data including totals and transaction history
export function usePensionContributions(memberNumber = null, enabled = false) {
  return useQuery({
    queryKey: ['pension-contributions', memberNumber],
    queryFn: async () => {
      try {
        const result = await serverRequest('GET', 'contributions');
        if (!result || !result.success) {
          throw new Error(result?.message || 'Failed to fetch pension contributions');
        }
        
        // Extract and calculate key values from transaction_history
        const history = result.data?.transaction_history || {};
        
        return {
          ...result,
          summary: {
            totalContributions: history.total_contribution_tally || 0,
            totalRedemption: history.total_redemption || 0, // Keep negative to show as deduction
            accruedInterest: history.gain_loss || 0,
            accountValue: history.account_value || 0,
            employerContribution: Math.abs(history.employer_contribution || 0),
            transferReceived: history.transfer_received || 0,
            unitsBroughtForward: history.units_bf || 0,
            currentPrice: history.current_price || 0,
            dateJoined: history.date_joined || '',
          },
          transactions: history.transactions || [],
          pagination: history.pagination || {},
        };
      } catch (error) {
        const errorMessage = extractErrorMessage(error, 'Failed to fetch pension contributions');
        notifyOnce("error", errorMessage, "Error");
        throw new Error(errorMessage);
      }
    },
    enabled: enabled && !!secureLocalStorage.getItem('token'),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
